<template>
  <RouterView />
</template>

<script setup lang="ts">
import { nextTick, onBeforeMount, onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { useConfigStore } from '@/stores/config';
import { useThemeStore } from '@/stores/theme';
import { useBodyStore } from '@/stores/body';
import { themeConfigValue } from '@/layouts/default-layout/config/helper';
import { initializeComponents } from '@/plugins/keenthemes';
import { useNetworkStatus } from './composables/networkStatus';

const configStore = useConfigStore();
const themeStore = useThemeStore();
const bodyStore = useBodyStore();

onBeforeMount(() => {
  /**
   * Overrides the layout config using saved data from localStorage
   * remove this to use static config (@/layouts/default-layout/config/DefaultLayoutConfig.ts)
   */
  configStore.overrideLayoutConfig();

  /**
   *  Sets a mode from configuration
   */
  themeStore.setThemeMode(themeConfigValue.value);
});

useNetworkStatus();

onMounted(() => {
  nextTick(() => {
    initializeComponents();
    bodyStore.removeBodyClassName('page-loading');
  });
});

</script>

<style lang="scss">
@import "bootstrap-icons/font/bootstrap-icons.css";
@import "apexcharts/dist/apexcharts.css";
@import "quill/dist/quill.snow.css";
@import "sweetalert2/dist/sweetalert2.css";
@import "@fortawesome/fontawesome-free/css/all.min.css";
@import "prism-themes/themes/prism-shades-of-purple.css";
@import "element-plus/dist/index.css";

// Main demo style scss
@import "assets/keenicons/duotone/style.css";
@import "assets/keenicons/outline/style.css";
@import "assets/keenicons/solid/style.css";
@import "assets/sass/element-ui.dark";
@import "assets/sass/plugins";
// @import "assets/sass/style";
@import "assets/sass/style.rtl";
@import "assets/sass/style.rtl.css";
#app {
  display: contents;
}
/* Always reserve scrollbar gutter to avoid layout shifts when scroll appears/disappears */
html {
  /* modern approach: reserve gutter without forcing visible scrollbar */
  scrollbar-gutter: stable;
}

/* fallback / explicit always-on scrollbar for browsers that don't support scrollbar-gutter */
body {
  min-height: 100vh;
  overflow-y: scroll;
}
</style>
